import React from 'react';
import { Translate } from 'react-localize-redux';

import envConfig from '../../constants/env';

import styles from './stickyBanner.module.css';

const StickyBanner = () => (envConfig.SHOW_DEMO_BANNER
  && (
    <div className={styles.container}>
      <div className={`messages info ${styles.messageBlock}`}>
        <p>
          <Translate id="environment.info.demo" />
        </p>
      </div>
    </div>
  )
);

export default StickyBanner;
